<template>
    <v-container fluid class="content-background" style="margin:0;padding:0;">
        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
            <NavBar_Variant></NavBar_Variant>
            <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :is-full-page="fullPage" />

            <v-row align="center" justify="center" id="result-download">
                <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                    <v-divider></v-divider>

                </v-col>
            </v-row>
            <v-row style="margin:0;padding:0;">
                <v-col>
                    <v-row>
                        <!--<v-col cols="0" md="0" lg="3" xl="3" justify="center" align="center"
                            style="margin:0;padding:0;">
                        </v-col>-->
                        <v-col cols="12" md="12" lg="4" xl="4" justify="center" align="center"
                            style="margin:0;padding:0;">
                            <v-row>
                                <div style="border:1px solid #f5f5f5;margin:auto;margin-top:20px;margin-bottom:10px;">
                                    <table style="width:100%;">
                                        <tr>
                                            <td>
                                                <div>
                                                    <!-- Pathogenicity scores (radar plot) -->
                                                    <v-card style="text-align:center;margin:0;padding:0;border:0px solid red;width:650px;"
                                                        class="elevation-0">
                                                        <div class="" @click="dialog_pathogenicity_biomarker_0 = true"
                                                            style="margin:auto;padding:0;width:650px;height:350px;text-align:center;border:0px solid red;">

                                                            <div id="pathogenicity-thumb-0"
                                                                v-html="this.$store.getters.getProcessState('load-pathogenicity-biomarker-0-thumb')"
                                                                style=""></div>
                                                            <div id="chart-pathogenicity-biomarker-0-thumb"
                                                                class="chart"
                                                                style="text-align:center;border:0px solid red;width:100%;height:300px;">
                                                            </div>

                                                        </div>
                                                         <v-btn @click="dialog_pathogenicity_biomarker_0 = true" style="margin-bottom:10px;">
                                                                Show<span style="width:10px;"></span>
                                                                <v-icon icon="mdi-arrow-expand" />
                                                         </v-btn>
                                                    </v-card>

                                                    <div class="text-center">
                                                        <v-dialog v-model="dialog_pathogenicity_biomarker_0" eager
                                                            style="margin:auto;width:auto;">
                                                            <v-card style="width:1600px;margin:auto;">
                                                                <v-btn
                                                                    @click="dialog_pathogenicity_biomarker_0 = false">
                                                                    Close</v-btn>
                                                                <div style="height:20px;"></div>
                                                                <div id="chart-pathogenicity-biomarker-0"
                                                                    style="width:1200px;height:1400px;"></div>
                                                            </v-card>
                                                        </v-dialog>
                                                    </div>
                                                </div>
                                            </td></tr>
                                            <!--<tr>
                                                <td>
                                                    <div>

                                                        <v-card style="text-align:center;margin:10px;width:500px;"
                                                            class="elevation-0">
                                                            <div class="" @click="dialog_pathogenicity_biomarker_1 = true"
                                                                style="margin:auto;width:500px;height:450px;text-align:center;">
                                                                <h5 style="margin-bottom:20px;">
                                                                    Grouped Pathogenicity
                                                                </h5>

                                                                <div id="pathogenicity-thumb-1"
                                                                    v-html="this.$store.getters.getProcessState('load-pathogenicity-biomarker-1-thumb')"
                                                                    style=""></div>
                                                                <div id="chart-pathogenicity-biomarker-1-thumb"
                                                                    class="chart"
                                                                    style="border:0px solid red;width:100%;height:350px;">
                                                                </div>

                                                                <v-btn @click="dialog_pathogenicity_1 = true">
                                                                    Show
                                                                    <span style="width:10px;"></span>
                                                                    <v-icon icon="mdi-arrow-expand" />
                                                                </v-btn>
                                                            </div>
                                                        </v-card>

                                                        <div class="text-center">
                                                            <v-dialog v-model="dialog_pathogenicity_biomarker_1" eager
                                                                style="margin:auto;width:auto;">
                                                                <v-card style="width:1600px;margin:auto;">
                                                                    <v-btn
                                                                        @click="dialog_pathogenicity_biomarker_1 = false">
                                                                        Close</v-btn>
                                                                    <div style="height:20px;"></div>
                                                                    <div id="chart-pathogenicity-biomarker-1"
                                                                        style="width:900px;height:1000px;"></div>
                                                                </v-card>
                                                            </v-dialog>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>-->
                                    </table>
                                </div>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <div class="content-box-toolbar-div">
                                        <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                                            density="compact">
                                            <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                                                Molecular features
                                            </v-toolbar-title>
                                        </v-toolbar>
                                    </div>
                                    <v-card class="elevation-1 content-box">
                                        <div class="content-box-header-space" style="height:35px;"></div>
                                         <v-table style="text-align:left;padding:0px;width:100%;">
                                            <tr>
                                                <td></td>
                                                <td>
                                                    <div style="padding:10px;">
                                                        <table style="width:100%;">
                                                            <tr>
                                                                <td><img :src="getRefAA(item['dbnsfp']['aaref'])" /></td>
                                                                <td>to</td>
                                                                <td><img :src="getRefAA(item['dbnsfp']['aaalt'])" /></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div ref="aarefviewer" id="aarefviewer" data-ui="false" class="viewer_3Dmoljs" style="width:50px; height:50px;"></div>
                                                    <div ref="aaaltviewer" id="aaaltviewer" data-ui="false" class="viewer_3Dmoljs"></div>
                                                </td>
                                            </tr>
                                        </v-table>
                                        <div v-if="'molecular_features' in item">
                                            <div v-if="'molecular_weight_alt' in item['molecular_features']">
                                                <v-table style="text-align:left;padding:10px;width:100%;">
                                                    <tr>
                                                        <td></td>
                                                        <td>Reference amino acid</td>
                                                        <td>Alternate amino acid</td>
                                                        <td>Difference</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Molecular weight</td>
                                                        <td>{{ item["molecular_features"]["molecular_weight_ref"] }} </td>
                                                        <td>{{ item["molecular_features"]["molecular_weight_alt"] }} </td>
                                                        <td>{{ item["molecular_features"]["molecular_weight_diff"]}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Charge at pH 7.4</td>
                                                        <td>{{ parseFloat(item["molecular_features"]["charge_at_pH_7_4_ref"]).toFixed(2) }}</td>
                                                        <td>{{ parseFloat(item["molecular_features"]["charge_at_pH_7_4_alt"]).toFixed(2) }}</td>
                                                        <td>{{ item["molecular_features"]["charge_at_pH_7_4_diff"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Aromaticity</td>
                                                        <td>{{item["molecular_features"]["aromaticity_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["aromaticity_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Flexibility</td>
                                                        <td>{{item["molecular_features"]["flexibility_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["flexibility_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ionizable</td>
                                                        <td>{{item["molecular_features"]["ionizable_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["ionizable_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Phosphorylation</td>
                                                        <td>{{item["molecular_features"]["phosphorylation_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["phosphorylation_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Polarity</td>
                                                        <td>{{item["molecular_features"]["polarity_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["polarity_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Solubility</td>
                                                        <td>{{item["molecular_features"]["solubility_ref"]}}</td>
                                                        <td>{{item["molecular_features"]["solubility_alt"]}}</td>
                                                        <td></td>
                                                    </tr>
                                                </v-table>

                                                                                                                <table>
                                                  <tr>
                                                <td>
                                                    <table style="margin:10px;">
                                                        <tr>
                                                            <td>
                                                                BLOSUM62
                                                            </td>
                                                            <td>
                                                                <v-icon size="1.5em"
                                                                    icon="mdi-tooltip-question"
                                                                    color="var(--dark-grey)"
                                                                    id="icon-pp2-hdiv-r"
                                                                    @click="showTooltip('icon-pp2-hdiv-r', 'blosum-desc')"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td>
                                                    <table>
                                                        <tr>
                                                            <td v-if="'molecular_features' in item">
                                                                {{ item['molecular_features']['blosum62'] }}
                                                            </td>
                                                    <td style="padding-left:10px;width:50px;">
                                                        <v-progress-linear v-model="blosum_val"
                                                            :color="blosum_color" height="25"
                                                            class="elevation-0">
                                                        </v-progress-linear>
                                                    </td></tr></table>
                                                </td>
                                            </tr>
                                            </table>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <!--<v-col cols="0" md="0" lg="3" xl="3" justify="center" align="center"
                            style="margin:0;padding:0;">
                        </v-col>-->


                        <v-col cols="12" md="6" lg="8" xl="8" justify="center" align="center"
                            style="margin:0;padding:0;">
                            <Results_ScoreBars></Results_ScoreBars>

                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" id="result-download" style="margin-bottom:20px;padding:0;">

                        <v-col cols="12" md="4" lg="4" xl="4" justify="center" align="center"
                            style="margin:0;padding:0;">
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xl="4" justify="center" align="center"
                            style="margin:0;padding:0;">
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

        </span>
    </v-container>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Variant from '@/components/navbars/NavBar_Variant';
import active_variants from "@/methods/active_variants";
import Results_ScoreBars from '@/components/query_result_components/Results_ScoreBars';
import axios from 'axios';
import Plotly from '@/assets/js/plotly-latest.min.js';
import useTooltip from '@/methods/tooltip.js';

export default {
    name: 'VariantPathogenicity',
    props: {
    },
    components: {
        Loading,
        NavBar_Variant,
        Results_ScoreBars,
    },
    data: function () {
        return {
            isLoading: false,
            fullPage: true,
            dataPathogenicity1: "",
            dialog_pathogenicity_biomarker_1: false,
            dataPathogenicity0: "",
            dialog_pathogenicity_biomarker_0: false,
            load_radar_0: '',
            load_radar_1: '',
        }
    },
    methods: {
        /**
         * Uses the tooltip composable to show a tooltip next to whatever was clicked (in this case v-icons for the pathogenicity scores).
         * @param {string} element_id - ID of the element (HTML)
         * @param {string} tooltip_id - ID of the tooltip in metadata.json
         * @param {string} tooltip_title - Title to show. Defaults to the one set in metadata.json if passed as undefined.
         */
        showTooltip (element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },  
        computePercentage(raw_score) {
            return int(float(raw_score) * 100)
        },
        getColor(value) {
            if ((value > 0) && (value < 0.25)) {
                return "#C0EDA6"
            } else if ((value >= 0.25) && (value < 0.5)) {
                return "#FFF7BC"
            } else if ((value >= 0.5) && (value < 0.75)) {
                return "#FF8080"
            } else if ((value > 0.75) && (value <= 1)) {
                return "#FD5D5D"
            }
            return "#e3e3e3"
        },
        shouldDisplayOncoKB(item) {
            if (item != undefined) {
                if ('oncokb' in item) {
                    if ('oncokb' in item['oncokb']) {
                        if ('exact_match' in item['oncokb']['oncokb']) {
                            if ('mutationEffect' in item['oncokb']['oncokb']['exact_match']) {
                                return true
                            }
                        }
                    }
                }
            }
            return false
        },
        redrawBiomarkerPathogenicityPlot(graphJSON) {
            this.dataPathogenicity1 = graphJSON
            var layout = { autosize: false, width: 200, height: 200, margin: { l: 20, r: 20, b: 20, t: 20, pad: 0 } }

            try {
                if (graphJSON !== undefined) {
                    graphJSON["layout"]["width"] = 800
                    graphJSON["layout"]["height"] = 600
                    graphJSON["layout"]["polar"] = {}
                    graphJSON["layout"]["font"] = { "size": 12 }
                    //graphJSON["layout"]["polar"]["bgcolor"]="#ffffff"
                    graphJSON["layout"]["polar"]["radialaxis"] = {}
                    graphJSON["layout"]["polar"]["radialaxis"]["visible"] = true
                    graphJSON["layout"]["polar"]["radialaxis"]["range"] = [0, 1.0]
                    graphJSON["layout"]["polar"]["radialaxis"]["gridcolor"] = "#303030"
                    graphJSON["layout"]["showlegend"] = true
                    graphJSON["layout"]["polar"]["angularaxis"] = {
                        "visible": true,
                        "gridcolor": "#303030"
                    }
                    //alert(screen.width)
                    //alert(JSON.stringify(graphJSON))
                    //alert(Object.keys(graphJSON))
                    Plotly.plot('chart-pathogenicity-biomarker-1-thumb', this.dataPathogenicity1, graphJSON);

                    graphJSON["layout"]["width"] = 800
                    graphJSON["layout"]["height"] = 600
                    graphJSON["layout"]["polar"] = {}
                    graphJSON["title"] = { "font": { "size": 18 } }
                    graphJSON["layout"]["font"] = { "size": 22 }
                    //graphJSON["layout"]["polar"]["bgcolor"]="#ffffff"
                    graphJSON["layout"]["polar"]["radialaxis"] = {}
                    graphJSON["layout"]["polar"]["radialaxis"]["visible"] = true
                    graphJSON["layout"]["polar"]["radialaxis"]["range"] = [0, 1.0]
                    graphJSON["layout"]["polar"]["radialaxis"]["gridcolor"] = "#303030"
                    graphJSON["layout"]["polar"]["radialaxis"]["color"] = "#303030"
                    graphJSON["layout"]["showlegend"] = true
                    graphJSON["layout"]["polar"]["angularaxis"] = {
                        "visible": true,
                        "gridcolor": "#303030"
                    }
                    Plotly.plot('chart-pathogenicity-biomarker-1', this.dataPathogenicity1, graphJSON);
                }
            } catch(error) {
                console.log(error)
            }
        },
        redrawBiomarkerPathogenicityPlot0(graphJSON) {
            this.dataPathogenicity1 = graphJSON
            var layout = { autosize: false, width: 200, height: 200, margin: { l: 20, r: 20, b: 20, t: 20, pad: 0 } }

            try {
                graphJSON["layout"]["width"] = 500
                graphJSON["layout"]["height"] = 300
                graphJSON["layout"]["polar"] = {}
                graphJSON["layout"]["font"] = { "size": 12 }
                //graphJSON["layout"]["polar"]["bgcolor"]="#ffffff"
                graphJSON["layout"]["polar"]["radialaxis"] = {}
                graphJSON["layout"]["polar"]["radialaxis"]["visible"] = true
                graphJSON["layout"]["polar"]["radialaxis"]["range"] = [0, 1.0]
                graphJSON["layout"]["polar"]["radialaxis"]["gridcolor"] = "#303030"
                graphJSON["layout"]["showlegend"] = true
                graphJSON["layout"]["polar"]["angularaxis"] = {
                    "visible": true,
                    "gridcolor": "#303030"
                }

                Plotly.plot('chart-pathogenicity-biomarker-0-thumb', this.dataPathogenicity1, graphJSON);

                graphJSON["layout"]["width"] = 1200
                graphJSON["layout"]["height"] = 700
                graphJSON["layout"]["polar"] = {}
                graphJSON["layout"]["font"] = { "size": 22 }
                graphJSON["layout"]["margin"] = { "t": 40 }
                //graphJSON["layout"]["polar"]["bgcolor"]="#ffffff"
                graphJSON["layout"]["polar"]["radialaxis"] = {}
                graphJSON["layout"]["polar"]["radialaxis"]["visible"] = true
                graphJSON["layout"]["polar"]["radialaxis"]["range"] = [0, 1.0]
                graphJSON["layout"]["polar"]["radialaxis"]["gridcolor"] = "#303030"
                graphJSON["layout"]["showlegend"] = true
                graphJSON["layout"]["polar"]["angularaxis"] = {
                    "visible": true,
                    "gridcolor": "#303030"
                }
                Plotly.plot('chart-pathogenicity-biomarker-0', this.dataPathogenicity1, graphJSON);
            } catch (error) {
                console.log(error)
            }
        },
                getBlosumPercentage(val) {
            switch (val) {
                case -4:
                    return 100
                case -3:
                    return 90
                case -2:
                    return 80
                case -1:
                    return 70
                case 0:
                    return 50
                case 1:
                    return 40
                case 2:
                    return 30
                case 3:
                    return 20
                case 4:
                    return 10
            }
            switch (val) {
                case "-4.0":
                    return 100
                case "-3.0":
                    return 90
                case "-2.0":
                    return 80
                case "-1.0":
                    return 70
                case "0.0":
                    return 50
                case "1.0":
                    return 40
                case "2.0":
                    return 30
                case "3.0":
                    return 20
                case "4.0":
                    return 10
            }
            return 0
        },
        getBlosumColor(val) {
            return "#7299b6"
            /*switch (val) {
                case -3:
                    return "#b50000"
            }
            switch (val) {
                case -4:
                    return "#f20000"
                case -3:
                    return "#e74f4f"
                case -2:
                    return "#e86a6a"
                case -1:
                    return "#e79898"
                case 0:
                    return "#dc8e1b"
                case 1:
                    return "#b8ea8a"
                case 2:
                    return "#9ddc63"
                case 3:
                    return "#88d93d"
                case 4:
                    return "#69bd1c"
            }
            return "#69bd1c"*/
        },
    },
    created: async function () {
    },
    mounted: async function () {
        this.isLoading = true
        let url = this.$store.getters.getPathVariable('methods_generate_plot')
        await active_variants.loadActiveBiomarkerSNV(this.$route.params.id)

        let activeBiomarkerQID = Object.keys(this.$store.getters.getActiveBiomarker)[0]
        let activeBiomarker = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]

        if ("molecular_features" in activeBiomarker) {
            if ("blosum62" in activeBiomarker["molecular_features"]) {
                this.blosum_val=this.getBlosumPercentage(activeBiomarker["molecular_features"]["blosum62"])
                this.blosum_color=this.getBlosumColor(activeBiomarker["molecular_features"]["blosum62"])
            }
        }

        let formData = new FormData();
        formData.append("plot", "pathogenicity-scores-radar");
        //formData.append("variant_data", JSON.stringify(this.$store.getters.getActiveBiomarker))


        let gene = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]["UTA_Adapter"]["gene_name"]
        let variant_exchange = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]["UTA_Adapter"]["variant_exchange"]
        let dbnsfp = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]["dbnsfp"]
        let variant_data_form =  { [activeBiomarkerQID]:
            { "UTA_Adapter": {"gene_name": gene, "variant_exchange": variant_exchange },
              dbnsfp
            }}
        //alert(JSON.stringify(variant_data_form))
        variant_data_form = JSON.stringify( variant_data_form )
        formData.append("variant_data", variant_data_form)

        formData.append("width", 1200)
        formData.append("height", 1000)

        await axios.post(url, formData, {
            headers: {
                "Content-Type": "text/html"
            }
        }).then((response) => {
            var response_data = response.data
            this.$store.dispatch("setProcessState", ["load-radar-0-thumb", "<div>" + response_data + "</div>"])
            this.TreatmentsSunburst1 = ""
            var graphJSON = response.data

            this.redrawBiomarkerPathogenicityPlot0(graphJSON)

            this.$store.dispatch('setProcessState', ["load-radar-0-thumb", ""])
        })

        /*formData = new FormData();
        formData.append("plot", "pathogenicity-scores-radar-categorical");
        formData.append("variant_data", JSON.stringify(this.$store.getters.getActiveBiomarker))
        formData.append("width", 1200)
        formData.append("height", 1000)

        await axios.post(url, formData, {
            headers: {
                "Content-Type": "text/html"
            }
        }).then((response) => {
            var response_data = response.data
            this.$store.dispatch("setProcessState", ["load-radar-1-thumb", "<div>" + response_data + "</div>"])
            this.TreatmentsSunburst1 = ""
            var graphJSON = response.data

            this.redrawBiomarkerPathogenicityPlot(graphJSON)

            this.$store.dispatch('setProcessState', ["load-radar-1-thumb", ""])
        })*/
        this.isLoading = false
    },
}
</script>
<style>
.bground-main {
    background-color: #ffffff;
}

.content-box {
    margin-left: 0px;
    text-align: left;
    padding: 20px;
}

.content-box-title {}

.content-box-header-space {
    height: 40px;
}

.content-box-toolbar-div {
    margin: auto;
    width: 90%;
    position: relative;
    top: 00px;
    z-index: 10;
}

.content-background {
    background-color: #ffffff;
}

.content-box-subtitle {
    padding-left: 10px;
    width: 100%;
}
</style>
